var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.333333, 1.333333)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1866667,4.10333333 L12.7206667,3.56933333 C13.536,2.75466667 13.536,1.42733333 12.7206667,0.612 C11.9306667,-0.177333333 10.554,-0.178 9.76333333,0.612 L9.22466667,1.15066667 L12.1866667,4.10333333 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2386667,5.05 L5.166,11.1226667 C5.114,11.174 5.05666667,11.216 4.99266667,11.248 L0.964,13.2626667 C0.707333333,13.3913333 0.397333333,13.34 0.194666667,13.1373333 C-0.008,12.9346667 -0.0586666667,12.6246667 0.07,12.368 L2.08333333,8.33933333 C2.116,8.27533333 2.158,8.218 2.20866667,8.166 L8.28133333,2.09333333 L11.2386667,5.05 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.de55f069ce8f204182313fe2fc3e91e7.svg";
export { ForwardRef as ReactComponent };